import React from 'react';
import { Fab, Zoom, useScrollTrigger } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const ScrollToTop = ({
    threshold = 100,
    //   color = '#0536E3',
    // color = '#00a0ff',
    color = 'rgba(10, 118, 250, 0.3)',
    //   hoverColor = '#042db8',
    // hoverColor = 'rgba(10, 118, 250, 0.3)',
    hoverColor = '#00a0ff',
    size = 'small',
    bottom = { xs: 80, sm: 80 },
    right = { xs: 16, sm: 32 }
}) => {
    const trigger = useScrollTrigger({
        threshold,
        disableHysteresis: true,
    });

    const handleClick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <Zoom in={trigger}>
            <Fab
                onClick={handleClick}
                sx={{
                    position: 'fixed',
                    bottom,
                    right,
                    bgcolor: color,
                    color: 'white',
                    '&:hover': {
                        bgcolor: hoverColor,
                    },
                    zIndex: 1000,
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
                    '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                        bgcolor: hoverColor,
                    },
                }}
                size={size}
                aria-label="scroll back to top"
            >
                <KeyboardArrowUpIcon />
            </Fab>
        </Zoom>
    );
};

export default ScrollToTop;